import { defineStore } from 'pinia';
import Config from '@/config';

export const useFeatureStore = defineStore('featureStore', {
	getters: {
		googleLoginEnabled(): boolean {
			return Config.FEATURE_LOGIN_GOOGLE_ENABLED;
		},
		azureAdLoginEnabled(): boolean {
			return Config.FEATURE_LOGIN_AZUREAD_ENABLED;
		},
		canCreateBusinessUnitWithAccountRequest(): boolean {
			return Config.FEATURE_BUSINESS_UNIT_CREATION_ENABLED !== false;
		}
	}
});
